import React from "react";

import PropTypes from "prop-types";

import RbAutocompleteControl from "components/RbAutocompleteControl";

const RbAutocompleteAsyncControl = React.forwardRef(
  function RbAutocompleteAsyncControl(props, ref) {
    const {
      filter,
      inputValue,
      onFilter,
      getOptionLabel,
      onInputChange,
      onOpen,
      onClose,
      value,
      ...other
    } = props;

    const [open, setOpen] = React.useState(false);

    const filterOptions = React.useCallback((options) => options, []);

    const handleInputChange = React.useCallback(
      (event) => {
        if (onInputChange) {
          onInputChange(event);
        }

        if (onFilter) {
          onFilter(event?.target?.value || "");
        }
      },
      [onInputChange, onFilter]
    );

    const handleOpen = React.useCallback(
      (event) => {
        setOpen(true);

        if (onOpen) {
          onOpen(event);
        }
      },
      [onOpen]
    );

    const handleClose = React.useCallback(
      (event) => {
        setOpen(false);
        onFilter("");

        if (onClose) {
          onClose(event);
        }
      },
      [onClose, onFilter]
    );

    return (
      <RbAutocompleteControl
        {...other}
        ref={ref}
        inputValue={inputValue || (open ? filter : getOptionLabel(value) || "")}
        onInputChange={handleInputChange}
        onOpen={handleOpen}
        onClose={handleClose}
        filterOptions={filterOptions}
        getOptionLabel={getOptionLabel}
        value={value}
      />
    );
  }
);

RbAutocompleteAsyncControl.propTypes = {
  filter: PropTypes.string.isRequired,
  getOptionLabel: PropTypes.func,
  inputValue: PropTypes.string,
  onClose: PropTypes.func,
  onFilter: PropTypes.func,
  onInputChange: PropTypes.func,
  onOpen: PropTypes.func,
  value: PropTypes.any,
};

function defaultGetOptionLabel(option) {
  return option?.name ?? option?.description ?? "";
}

RbAutocompleteAsyncControl.defaultProps = {
  getOptionLabel: defaultGetOptionLabel,
  inputValue: undefined,
  onClose: undefined,
  onFilter: undefined,
  onInputChange: undefined,
  onOpen: undefined,
  value: undefined,
};

export default React.memo(RbAutocompleteAsyncControl);
